var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skill-icons:instagram",
    clipPath: "url(#clip0_572_24977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.875 0.446167H6.125C3.0184 0.446167 0.5 2.96457 0.5 6.07117V18.8212C0.5 21.9278 3.0184 24.4462 6.125 24.4462H18.875C21.9816 24.4462 24.5 21.9278 24.5 18.8212V6.07117C24.5 2.96457 21.9816 0.446167 18.875 0.446167Z",
    fill: "url(#paint0_radial_572_24977)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.875 0.446167H6.125C3.0184 0.446167 0.5 2.96457 0.5 6.07117V18.8212C0.5 21.9278 3.0184 24.4462 6.125 24.4462H18.875C21.9816 24.4462 24.5 21.9278 24.5 18.8212V6.07117C24.5 2.96457 21.9816 0.446167 18.875 0.446167Z",
    fill: "url(#paint1_radial_572_24977)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5008 3.07117C9.95478 3.07117 9.63519 3.08232 8.63525 3.12779C7.63719 3.17354 6.95591 3.33151 6.35984 3.56335C5.74316 3.80279 5.22013 4.12314 4.69906 4.64439C4.17753 5.16554 3.85719 5.68857 3.617 6.30498C3.3845 6.90123 3.22634 7.58279 3.18144 8.58039C3.13672 9.58042 3.125 9.9001 3.125 12.4463C3.125 14.9924 3.13625 15.311 3.18163 16.3109C3.22756 17.309 3.38553 17.9903 3.61719 18.5863C3.85681 19.203 4.17716 19.726 4.69841 20.2471C5.21938 20.7686 5.74241 21.0897 6.35862 21.3292C6.95516 21.561 7.63653 21.719 8.63441 21.7647C9.63444 21.8102 9.95375 21.8214 12.4997 21.8214C15.0461 21.8214 15.3646 21.8102 16.3646 21.7647C17.3626 21.719 18.0447 21.561 18.6412 21.3292C19.2576 21.0897 19.7799 20.7686 20.3007 20.2471C20.8223 19.726 21.1425 19.203 21.3828 18.5866C21.6133 17.9903 21.7715 17.3088 21.8184 16.3111C21.8633 15.3112 21.875 14.9924 21.875 12.4463C21.875 9.9001 21.8633 9.5806 21.8184 8.58057C21.7715 7.58251 21.6133 6.90132 21.3828 6.30526C21.1425 5.68857 20.8223 5.16554 20.3007 4.64439C19.7793 4.12295 19.2578 3.8026 18.6406 3.56345C18.043 3.33151 17.3613 3.17345 16.3632 3.12779C15.3632 3.08232 15.0448 3.07117 12.4979 3.07117H12.5008ZM11.6598 4.76064C11.9095 4.76026 12.188 4.76064 12.5008 4.76064C15.0041 4.76064 15.3007 4.76964 16.2892 4.81454C17.2032 4.85635 17.6994 5.00907 18.0298 5.13742C18.4674 5.30729 18.7793 5.51045 19.1072 5.83867C19.4353 6.16679 19.6384 6.47926 19.8088 6.91679C19.9371 7.24679 20.09 7.74292 20.1316 8.65698C20.1765 9.64529 20.1863 9.9421 20.1863 12.4441C20.1863 14.9461 20.1765 15.243 20.1316 16.2312C20.0898 17.1453 19.9371 17.6414 19.8088 17.9715C19.6389 18.409 19.4353 18.7206 19.1072 19.0485C18.7791 19.3766 18.4676 19.5797 18.0298 19.7497C17.6997 19.8786 17.2032 20.0309 16.2892 20.0727C15.3009 20.1176 15.0041 20.1274 12.5008 20.1274C9.99753 20.1274 9.70081 20.1176 8.71259 20.0727C7.79853 20.0305 7.30241 19.8778 6.97166 19.7495C6.53422 19.5795 6.22166 19.3764 5.89353 19.0483C5.56541 18.7202 5.36234 18.4085 5.192 17.9708C5.06366 17.6407 4.91075 17.1445 4.86913 16.2305C4.82422 15.2422 4.81522 14.9454 4.81522 12.4418C4.81522 9.93826 4.82422 9.64295 4.86913 8.65464C4.91094 7.74057 5.06366 7.24445 5.192 6.91398C5.36197 6.47645 5.56541 6.16398 5.89363 5.83585C6.22175 5.50773 6.53422 5.30457 6.97175 5.13432C7.30222 5.00542 7.79853 4.85307 8.71259 4.81107C9.57744 4.77198 9.91259 4.76026 11.6598 4.75829V4.76064ZM17.5052 6.31726C16.8841 6.31726 16.3802 6.8207 16.3802 7.44189C16.3802 8.06298 16.8841 8.56689 17.5052 8.56689C18.1263 8.56689 18.6302 8.06298 18.6302 7.44189C18.6302 6.82079 18.1263 6.31689 17.5052 6.31689V6.31726ZM12.5008 7.63173C9.84209 7.63173 7.68641 9.78742 7.68641 12.4463C7.68641 15.1051 9.84209 17.2598 12.5008 17.2598C15.1597 17.2598 17.3146 15.1051 17.3146 12.4463C17.3146 9.78751 15.1595 7.63173 12.5007 7.63173H12.5008ZM12.5008 9.3212C14.2267 9.3212 15.6259 10.7202 15.6259 12.4463C15.6259 14.1721 14.2267 15.5713 12.5008 15.5713C10.7749 15.5713 9.37588 14.1721 9.37588 12.4463C9.37588 10.7202 10.7749 9.3212 12.5008 9.3212Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_572_24977",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.875 26.2946) rotate(-90) scale(23.7858 22.1227)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_572_24977",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.52009 2.17501) rotate(78.681) scale(10.6324 43.827)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_572_24977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.446167)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.987fcfb7f02d785c9eb506f6110a754b.svg";
export { ForwardRef as ReactComponent };